// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"DependenciesList_tableContainer__3FpW8","cardTitle":"DependenciesList_cardTitle__2gbKy"};